import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  ErrorItem,
} from "../../../../Components/Items";

class EditarCanal extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    visible: this.props.visible,
    canal: this.props.canal || {},  // Cargar datos iniciales del canal
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.formRef.current.resetFields();
      this.consultarDatosCanal(this.props.canal._id);
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  consultarDatosCanal(id) {
    this.setState({ loading: true });
    axios
      .post(
        "canalesVenta/datosCanalVenta",
        { canalVentaId: id },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
          message.error("No se encontraron los datos del canal");
        } else {
          const { codigo, nombre, descripcion } = res.data.canalVenta;
          this.formRef.current.setFieldsValue({
            codigo,
            nombre,
            descripcion,
          });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "canalesVenta/editarCanalVenta",
        {
          ...values,
          canalVentaId: this.props.canal._id,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Canal actualizado exitosamente");
          this.cerrarModal();
        } else {
          message.error("No se pudo actualizar el canal");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  cerrarModal = () => {
    this.props.cerrarModal();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  render() {
    return (
      <ModalItem
        title="Editar Canal de Venta"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal}
        width={800}
      >
        <Form
          ref={this.formRef}
          name="modalEditarCanal"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          {/* Campo para el código del canal */}
          <FormItem
            name="codigo"
            label="Codigo"
            required
            margin
          >
            <InputItem placeholder="Ingresa el código del canal" />
          </FormItem>

          {/* Campo para el nombre del canal */}
          <FormItem
            name="nombre"
            label="Nombre del Canal"
            required
            margin
          >
            <InputItem placeholder="Ingresa el nombre del canal" />
          </FormItem>

          {/* Campo para la descripción del canal */}
          <FormItem
            name="descripcion"
            label="Descripción del Canal"
            margin
          >
            <InputItem placeholder="Ingresa una breve descripción del canal" />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EditarCanal);
